import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import KakobuyArticlePage from "../pages/article-kakobuy/page";
import CssbuyArticlePage from "../pages/article-cssbuy/page";
import SuperbuyArticlePage from "../pages/article-superbuy/page";
import OopbuyArticlePage from "../pages/article-oopbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide/",
    element: <ArticlePage />,
  },
  {
    path: "/kakobuy-spreadsheet-guide/",
    element: <KakobuyArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-guide/",
    element: <CssbuyArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-guide/",
    element: <SuperbuyArticlePage />,
  },
  {
    path: "/oopbuy-spreadsheet-guide/",
    element: <OopbuyArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;